export default class FieldsConstants {
  public static readonly MIN_BASE: number = 0;
  public static readonly MAX_BASE: number = 50;
  public static readonly MIN_EMAIL_LEN: number = 6;
  public static readonly MAX_EMAIL_LEN: number = 254;
  public static readonly MIN_PASSWORD_LEN: number = 10;
  public static readonly MAX_PASSWORD_LEN: number = 50;
  public static readonly MIN_ALIAS_LEN: number = 1;
  public static readonly MAX_ALIAS_LEN: number = 100;
  public static readonly MIN_ORGANIZATION_NAME_LEN: number = 1;
  public static readonly MAX_ORGANIZATION_NAME_LEN: number = 100;
  public static readonly MIN_FIRST_NAME_LEN: number = 1;
  public static readonly MAX_FIRST_NAME_LEN: number = 50;
  public static readonly MIN_MIDDLE_NAME_LEN: number = 1;
  public static readonly MAX_MIDDLE_NAME_LEN: number = 50;
  public static readonly MIN_LAST_NAME_LEN: number = 1;
  public static readonly MAX_LAST_NAME_LEN: number = 50;
  public static readonly MIN_ZIP_CODE_LEN: number = 1;
  public static readonly MAX_ZIP_CODE_LEN: number = 18;

  public static readonly MAX_FILE_SIZE: number = 4;
  public static readonly MIN_IMAGE_WIDTH: number = 180;
  public static readonly MIN_IMAGE_HEIGHT: number = 180;
  public static readonly MIN_FILE_WIDTH: number = 1000;
  public static readonly MIN_FILE_HEIGHT: number = 1000;

  public static readonly DEACTIVATE_ACCOUNT_REASON_MAX_LENGTH: number = 100;
  public static readonly REACTIVATION_PETITION_MAX_LENGTH: number = 2000;
  public static readonly DECLINE_REACTIVATION_PETITION_MAX_LENGTH: number = 2000;

  public static readonly MAX_COMMENT_LENGTH: number = 2000;

  public static readonly MAX_MIN_VERIFICATION_CODE_LEN: number = 6;

  public static readonly MIN_WEBSITE_LINK_LENGTH: number = 7;
  public static readonly MAX_WEBSITE_LINK_LENGTH: number = 300;

  public static readonly IMAGE_GIF_FILE: string = 'image/gif';
  public static readonly ALLOWED_FILE_MANAGER_DOCUMENTS_EXTENSIONS: string[] = [
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.rtf',
    '.pdf',
    '.zip',
    '.7z',
    '.tar',
    '.gz',
    '.rar',
    '.pages',
  ];
  public static readonly ALLOWED_FILE_MANAGER_IMAGE_EXTENSIONS: string[] = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.psd',
    '.ps',
    '.bmp',
    '.psb',
    '.raw',
    '.heic',
  ];
  public static readonly ALLOWED_FILE_MANAGER_VIDEO_EXTENSIONS: string[] = ['.mov', '.mp4', '.avi'];
  public static readonly ALLOWED_FILE_MANAGER_AUDIO_EXTENSIONS: string[] = ['.mp3', '.wave', '.wav', '.m4a'];

  public static readonly ALLOWED_IMAGES_EXTENSIONS: string[] = ['.png', '.jpg', '.jpeg', '.gif'];

  public static readonly EXTENSION_MIME_TYPE: string[] = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    'application/vnd.ms-word.document.macroEnabled.12',
    'application/vnd.ms-word.template.macroEnabled.12',

    'application/vnd.ms-excel',

    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    'application/vnd.ms-excel.sheet.macroEnabled.12',
    'application/vnd.ms-excel.template.macroEnabled.12',
    'application/vnd.ms-excel.addin.macroEnabled.12',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',

    'application/vnd.ms-powerpoint',

    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.template',
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    'application/vnd.ms-powerpoint.template.macroEnabled.12',
    'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',

    'application/vnd.ms-access',
  ];

  public static readonly MAX_FILE_MANAGER_FILE_SIZE_IN_BYTE: number = 314572800;
  public static readonly MAX_FILE_MANAGER_FILE_SIZE_IN_BYTE_IOS: number = 300000000;

  public static readonly MIN_YEAR_ALLOW: number = 1900;

  public static SEARCH_DEFAULT_RESULTS_COUNT = 10;
  public static PAGINABLE_SEARCH_RESULT_COUNT = 20;
  public static CONTACT_US_FOLDER_SUFFIX_NAME = 'contact-us';
  public static MAX_RICH_TEXT_EDITOR_IMAGES_COUNT = 15;
  public static MAX_RICH_TEXT_EDITOR_SYMBOLS_COUNT = 50000;
  public static CHAT_MAX_MESSAGE_LENGTH = 1000;
  public static CHAT_MAX_TITLE_LENGTH = 100;
  public static SEARCH_DEFAULT_RESULTS_COUNT_MAX = 10000;
  public static NUMBER_CHARACTER_REPETITION_IN_STRING = 6;
  public static CHARACTER_FOR_SMS_CODE = 'x';
}
